import SquaresDashboardHandler from 'handlers/squaresHandlers/squaresDashboard.handler';
import { useDispatch } from 'react-redux';
import { updateLoadingState } from 'store/app.slice';
import {
  type MaintenanceSquares,
  type DashboardSquares,
} from 'types/squares.type';

export const useFetchPmVsCmVsModification = () => {
  const dispatch = useDispatch();
  const squaresHandler = new SquaresDashboardHandler();

  const fetchData = async (
    selectedStartDate: Date,
    selectedEndDate: Date
  ): Promise<DashboardSquares[]> => {
    dispatch(updateLoadingState(true));
    try {
      const squaresData = await squaresHandler.getPmVsCmVsModification(
        selectedStartDate,
        selectedEndDate
      );
      return squaresData.Items;
    } catch (error) {
      console.error(error);
      return []; // Return an empty array in case of an error
    } finally {
      dispatch(updateLoadingState(false));
    }
  };

  return fetchData;
};

export const useFetchPmVsCmExpenditures = () => {
  const dispatch = useDispatch();
  const squaresHandler = new SquaresDashboardHandler();
  const fetchData = async (
    selectedStartDate: Date,
    selectedEndDate: Date
  ): Promise<MaintenanceSquares[]> => {
    dispatch(updateLoadingState(true));
    try {
      const squaresData = await squaresHandler.getPmVsCmExpenditures(
        selectedStartDate,
        selectedEndDate
      );
      return squaresData.Items;
    } catch (error) {
      console.error(error);
      return []; // Return an empty array in case of an error
    } finally {
      dispatch(updateLoadingState(false));
    }
  };

  return fetchData;
};
